export default class DictionaryModel {
  public reason: string = "";
  public words: string[] = [];
}
